// 为每个淘宝表单控件提供vuex中的淘宝的一些方法
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { getItemPublishSchemaProp } from '@/servers/prod/center/tjb';

export default {
  data() {
    return {
      options: [],
      isAsyncOptions: false,
    }
  },
  computed: {
    ...mapGetters(['tjbForm', 'tjbData', 'tjbOptions', 'shops_defaultShopId', 'shops_updateShopId', 'shops_updateIndex', 'shops_all', 'shops_getCategoryPropShopId', 'removePureItem']),
    // options() {
    //   // console.log('this: ', this);
    //   let opts = this.props.dataSource.options
    //   if (opts.length <= 0) {
    //     getItemPublishSchemaProp({}).then(res => {
    //       console.log('res: ', res);

    //     })
    //   }
    //   return opts;
    // },
  },
  watch: {
    props: {
      immediate: true,
      handler: function(v) {
        if (!v || !v.dataSource) return;

        const {options, name, label, parentName} = v.dataSource
        if (options && options.length) {
          this.options = options.map(item => ({...item, pLabel: label}))
          this.isAsyncOptions = false
        } else if (this.isHasOptionsComp) {
          // 需要选项的组件 调用接口请求选项列表
          let shopId = parentName === 'catProp' ? this.shops_getCategoryPropShopId('tjb')
          : this.shops_defaultShopId('tjb')
          getItemPublishSchemaProp({
            shopId: shopId,
            baseItemId: '',
            // catId: 162205,
            catId: this.tjbForm.categoryIds[this.tjbForm.categoryIds.length - 1],
            propId: name.replace('p-', '')
          }).then(res => {
            // 待优化成分页
            // 现在数据量过大导致页面卡顿
            // 目前只取前99条
            // this.options = res.options.slice(0, 99).map(item => ({...item, pLabel: label}))
            this.initTjbOptions({key: name, options: (res.options || []).map(item => ({...item, pLabel: label}))})
            this.isAsyncOptions = true
          })
        }
      }
    }
  },
  methods: {
    ...mapActions(['initTjbForm', 'updateTjbForm', 'initTjbOptions']),
  },
}

